import NetEffectiveRentTooltip from "./NetEffectiveRentTooltip";

export default NetEffectiveRentTooltip;
